"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Picker = void 0;

var _react = _interopRequireWildcard(require("react"));

var _formik = require("formik");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _SearcherDropdown = _interopRequireDefault(require("@lt/components/components/SearcherDropdown"));

var _TouristsPicker = _interopRequireDefault(require("@lt/components/components/TouristsPicker"));

var _styles = require("@lt/components/components/DurationTrip/styles");

var _DropdownIndicator = _interopRequireDefault(require("./components/DropdownIndicator"));

var _constants = require("./constants");

var _constants2 = require("../../constants");

var _touristPickerModule = _interopRequireDefault(require("./touristPicker.module.css"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _excluded = ["isWizard", "isMobile", "className", "variant", "isOpenInitial", "setBodyLocked", "searchType", "isWhiteLabel", "renderPopupComponent", "onChangeAdults", "adultsValue", "maxValue", "maxChildren", "kidsValue", "onChangeKids", "isSearcher"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Выбор туристов
 */
var Picker = function Picker(props) {
  var _clsx;

  var isWizard = props.isWizard,
      isMobile = props.isMobile,
      className = props.className,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'default' : _props$variant,
      isOpenInitial = props.isOpenInitial,
      setBodyLocked = props.setBodyLocked,
      searchType = props.searchType,
      _props$isWhiteLabel = props.isWhiteLabel,
      isWhiteLabel = _props$isWhiteLabel === void 0 ? false : _props$isWhiteLabel,
      renderPopupComponent = props.renderPopupComponent,
      onChangeAdults = props.onChangeAdults,
      adultsValue = props.adultsValue,
      maxValue = props.maxValue,
      maxChildren = props.maxChildren,
      kidsValue = props.kidsValue,
      onChangeKids = props.onChangeKids,
      isSearcher = props.isSearcher,
      otherProps = _objectWithoutProperties(props, _excluded);

  var _useFormikContext = (0, _formik.useFormikContext)(),
      setFieldValue = _useFormikContext.setFieldValue;

  var isHotelVariant = variant === 'hotel';

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isPopupShown = _useState2[0],
      setPopupShown = _useState2[1];

  (0, _react.useEffect)(function () {
    sessionStorage.setItem('adultsValue', "".concat(adultsValue));
    sessionStorage.setItem('kidsValue', "".concat(JSON.stringify(kidsValue)));

    if (maxValue && adultsValue > maxValue || maxChildren && kidsValue !== null && kidsValue !== void 0 && kidsValue.length && (kidsValue === null || kidsValue === void 0 ? void 0 : kidsValue.length) > maxChildren) {
      setFieldValue(_constants2.FIELD_NAMES.tourists, _constants2.INITIAL_VALUES_FORMIK.tourists, false);
      setPopupShown(true);
    }
  }, [maxValue, maxChildren]);
  return /*#__PURE__*/_react["default"].createElement(StyledTouristsPicker, {
    $isWizard: isWizard,
    $isMobile: isMobile,
    className: (0, _clsx2["default"])(_touristPickerModule["default"].touristsPicker, className, (_clsx = {}, _defineProperty(_clsx, _touristPickerModule["default"].touristsPickerMobile, isMobile && !isWizard), _defineProperty(_clsx, _touristPickerModule["default"].touristsPickerDesktop, !isMobile), _defineProperty(_clsx, _touristPickerModule["default"].leftBorder, !isMobile), _defineProperty(_clsx, _touristPickerModule["default"].touristsPickerWizard, isWizard), _defineProperty(_clsx, _touristPickerModule["default"].touristsPickerHotel, variant === 'hotel'), _defineProperty(_clsx, _touristPickerModule["default"].touristsPickerDesktopHotelSearch, !isMobile && searchType === _constants2.SEARCH_TYPE_NAMES.HOTEL), _clsx)),
    $variant: variant
  }, isMobile && !isWizard && /*#__PURE__*/_react["default"].createElement(_styles.MobileLabel, {
    $isWhiteLabel: isWhiteLabel,
    $variant: variant
  }, _constants.touristsPlaceholder), /*#__PURE__*/_react["default"].createElement(_TouristsPicker["default"], _extends({}, otherProps, {
    setBodyLocked: setBodyLocked,
    isMobile: isMobile,
    isMobileInput: isMobile,
    CustomDropdownIndicator: _DropdownIndicator["default"],
    isOpenInitial: isOpenInitial,
    isWhiteLabel: isWhiteLabel,
    adultsValue: adultsValue,
    kidsValue: kidsValue,
    maxValue: maxValue,
    maxChildren: maxChildren,
    onChangeAdults: onChangeAdults,
    onChangeKids: onChangeKids,
    isSearcher: isHotelVariant
  })), isPopupShown && (renderPopupComponent === null || renderPopupComponent === void 0 ? void 0 : renderPopupComponent({
    isMobile: isMobile,
    isOpen: isPopupShown,
    onClose: function onClose() {
      setPopupShown(false);
    }
  })));
};

exports.Picker = Picker;

var StyledTouristsPicker = _styledComponents["default"].div.withConfig({
  displayName: "TouristsPicker__StyledTouristsPicker",
  componentId: "sc-1ta9jvd-0"
})(["", "{border-radius:var(--border-radius);box-shadow:none;", " ", " &:hover{border:0;box-shadow:none;}}"], _SearcherDropdown["default"].Input, function (_ref) {
  var $isMobile = _ref.$isMobile,
      $isWizard = _ref.$isWizard;
  return $isMobile && !$isWizard && (0, _styledComponents.css)(["height:48px;"]);
}, function (_ref2) {
  var $variant = _ref2.$variant;
  return $variant === 'hotel' && (0, _styledComponents.css)(["background-color:var(--background);"]);
});